import { makeDefaultBreakRuleFields } from 'page/Settings/components';
import { TimesheetSettings } from 'type';

export default function makeFormFields(settings: TimesheetSettings) {
  return {
    ...settings,
    default_breaks_rules: makeDefaultBreakRuleFields(
      settings.default_breaks_rules
    ),
  };
}

export type FormFields = ReturnType<typeof makeFormFields>;
